import './Loading.css';

import { PulseLoader  } from 'halogenium';
import * as React from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';

export interface ILoadingProps {
  isBusy: boolean;
}

const mapStateToProps = (state: any): any => {
  return {
    isBusy: state.loading.isBusy,
  };
};

@(connect(mapStateToProps, null) as any)
export default class Loading extends React.Component<any, any>{
  render() {
    const show = this.props.isBusy;

    return show ? createPortal(
      <div className="loading-container">
        <PulseLoader color="#fff" size="16px" margin="4px" /> 
      </div>,
      document.body) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.tsx